<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="toc-title">CONTENTS</p>
<p class="toca"><a href="#/xhtml/05_Introduction">Introduction and Acknowledgements</a></p>
<p class="toc1"><a href="#/xhtml/07_Chapter01">Chapter 1         Halfway Back</a></p>
<p class="toc1"><span href="#/xhtml/08_Chapter02" title="Link target outside of Sample">Chapter 2         Disasters on the Gazala Line</span></p>
<p class="toc1"><span href="#/xhtml/09_Chapter03" title="Link target outside of Sample">Chapter 3         Above the Waves, 1 February – 30 June 1942</span></p>
<p class="toc1"><span href="#/xhtml/10_Chapter04" title="Link target outside of Sample">Chapter 4         The Yanks are Coming!</span></p>
<p class="toc1"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample">Chapter 5         The Stand on the El Alamein Line</span></p>
<p class="toc1"><span href="#/xhtml/12_Chapter06" title="Link target outside of Sample">Chapter 6         The Battle of Alam El Halfa</span></p>
<p class="toc1"><span href="#/xhtml/13_Chapter07" title="Link target outside of Sample">Chapter 7         The Battle of El Alamein</span></p>
<p class="toc1"><span href="#/xhtml/14_Chapter08" title="Link target outside of Sample">Chapter 8         Pursuit into Tripolitania</span></p>
<p class="toc1"><span href="#/xhtml/15_Chapter09" title="Link target outside of Sample">Chapter 9         The Mareth Line</span></p>
<p class="toc1"><span href="#/xhtml/16_Chapter10" title="Link target outside of Sample">Chapter 10       Above the Waves, 1 July 1942 – 31 March 1943</span></p>
<p class="toc1"><span href="#/xhtml/17_Chapter11" title="Link target outside of Sample">Chapter 11       The Allied Heavy Bombing Offensive</span></p>
<p class="toca"><span href="#/xhtml/18_Bibliography" title="Link target outside of Sample">Bibliography</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?dc2d3f72